import { render, staticRenderFns } from "./VueSelect.vue?vue&type=template&id=b6cd657c&scoped=true"
import script from "./VueSelect.vue?vue&type=script&lang=js"
export * from "./VueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cd657c",
  null
  
)

export default component.exports